import { QueryKey, useMutation } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

import { queryClient } from '../../configs/queryClient';

async function update(axios: AxiosInstance, workshopUpdateRequestId: number, dataForEndpoint: any): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v1/workshop-update-request/${workshopUpdateRequestId}`, dataForEndpoint);
  return data;
}

export default function useUpdateWorkshopUpdateRequestStatus(workshopUpdateRequestId: number, queryKey: QueryKey) {
  const axios = useAxios();

  return useMutation({
    mutationFn: (dataForEndpoint: any) => update(axios, workshopUpdateRequestId, dataForEndpoint),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });
}
